import React, { Component } from "react";
import {
  Container,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
  ModalFooter,
  UncontrolledTooltip
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faArrowUp,
  faCheck,
  faFileCsv,
  faInfoCircle
} from "@fortawesome/free-solid-svg-icons";
import {
  errorNotification,
  dismissNotifications,
  successNotification
} from "../../../utils/notifications";
import FileDownload from "js-file-download";
import {
  postMassiveLoad,
  postValidateSpecialGuest,
  postSaveSpecialGuest
} from "../../actions/invitados";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  company: object;
  companyId: string;
}

interface State {
  file: File | null;
  loading: boolean;
  data: [];
  validateFile: boolean;
  hasGuestToSave: boolean;
  username: string;
}

export default class MassiveLoadSpecialGuests extends Component<Props, State> {
  fileInputRef: React.RefObject<HTMLInputElement> = React.createRef();

  state = {
    file: null,
    loading: false,
    data: [],
    validateFile: false,
    hasGuestToSave: false,
    username: ""
  };

  // Prevenir los eventos por defecto para que funcione el drop
  handleDrag = event => {
    event.preventDefault();
    event.stopPropagation();
  };

  // Manejar el archivo soltado
  handleDrop = event => {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer.files && event.dataTransfer.files[0]) {
      this.processFile(event.dataTransfer.files[0]);
    }
  };

  handleFileChange = event => {
    this.setState({
      loading: true
    });
    event.preventDefault();
    event.stopPropagation();
    const files = event.target.files;
    if (files && files[0]) {
      this.processFile(files[0]);
    }
  };

  processFile = (pFile: File) => {
    dismissNotifications();
    const aExtension = ["csv"];

    const index = pFile.name.indexOf(".");
    if (index >= 0) {
      const extension = pFile.name.substring(index + 1, pFile.name.length);
      if (!aExtension.includes(extension)) {
        errorNotification("Solo se permiten archivos tipo: " + aExtension);
        return;
      }
      this.setState({ file: pFile, loading: false });
    }
  };

  reset = () => {
    this.setState({
      file: null,
      loading: false,
      data: [],
      validateFile: false,
      hasGuestToSave: false,
      username: ""
    });
  };

  downloadTemplate = () => {
    try {
      const aHeader =
        "Nombre,Apellido Paterno,Apellido Materno,Email,CC,Telefono,Sexo,Fecha nacimiento,CURP,CURP Familiar,Extranjero,Inicio vigencia,Fin vigencia";
      const rowTemplate =
        "OXFORD,JOHN,DOE,email@yopmail.com,email.cc@yopmail.com,'5517894714',H,'1990-01-01',XXXX000000XXXXXX00,XXXX000000XXXXXX00,FMX-extranjero-code,'01-01-2026','01-02-2026',Nota:,Las comillas simples ('') que aparecen en el teléfono y en fechas son para que excel no modifique el formato; NO agregarlas cuando se valide el archivo.";
      FileDownload(
        `${aHeader}\n${rowTemplate}`,
        "plantilla_invitados_especiales.csv"
      );
    } catch (error) {
      errorNotification("No se pudo descargar la plantilla");
    }
  };

  validatePersons = async e => {
    e.preventDefault();
    this.setState({ loading: true });

    try {
      const personResponse = await postMassiveLoad(this.state.file);
      let hasGuestToSave =
        personResponse.data.persons.filter(g => g.errors.length == 0).length >
        0;

      if (hasGuestToSave) {
        const lGuest = personResponse.data.persons
          .filter(g => g.errors.length == 0)
          .map(g => {
            return {
              personId: g.personId,
              startsAt: g.startsAt,
              expiresAt: g.expiresAt
            };
          });

        const request = {
          specialGuests: lGuest,
          companyId: this.props.companyId
        };

        const guestResponse = await postValidateSpecialGuest(request);

        personResponse.data.persons
          .filter(p => p.errors.length == 0)
          .forEach(p => {
            const guest = guestResponse.data.lspecialGuest
              .filter(g => g.errors.length > 0)
              .find(g => g.personId === p.personId);
            p.errors = guest ? guest.errors : p.errors;
          });

        hasGuestToSave =
          personResponse.data.persons.filter(g => g.errors.length == 0).length >
          0;
      }
      this.setState({
        data: personResponse.data.persons,
        loading: false,
        validateFile: true,
        hasGuestToSave: hasGuestToSave,
        username: personResponse.data.username
      });
    } catch (error) {
      const eMessage =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : "Ha ocurrido un error validando el archivo";
      errorNotification(eMessage);
      this.reset();
    }
  };

  saveSpecialGuest = async e => {
    e.preventDefault();
    this.setState({ loading: true });

    const nData = this.state.data
      .filter(g => g.errors.length == 0)
      .map(g => {
        return {
          personId: g.personId,
          personIdRelative: g.personIdRelative,
          name:
            (g.firstName && g.firstName.trim()) +
            " " +
            (g.paternalLastName && g.paternalLastName.trim()) +
            " " +
            (g.maternalLastName && g.maternalLastName.trim()),
          email: g.email,
          cc: g.cc,
          startsAt: g.startsAt,
          expiresAt: g.expiresAt
        };
      });

    const request = {
      specialGuests: nData,
      companyId: this.props.companyId,
      username: this.state.username
    };

    postSaveSpecialGuest(request)
      .then(r => {
        successNotification("Listo, invitados agregados");
        this.reset();
      })
      .catch(error => {
        const eMessage =
          error.response && error.response.data && error.response.data.error
            ? error.response.data.error
            : "Ha ocurrido un error guardando los invitados";
        errorNotification(eMessage);
        this.setState({ loading: false });
      });
  };

  render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        toggle={this.props.toggle}
        size="xl"
        scrollable={"true"}
        backdrop="static"
      >
        <ModalBody>
          <ModalHeader toggle={this.props.toggle}>
            Alta masiva de usuarios
          </ModalHeader>

          {!this.state.file && (
            <Button
              color="link"
              onClick={this.downloadTemplate}
              disabled={this.state.loading}
              className="btn-link p-0 m-0"
            >
              Descargar plantilla
            </Button>
          )}

          <Container className="mt-4">
            {!this.state.data || this.state.data.length === 0 ? (
              <>
                <div
                  onClick={() => {
                    if (this.fileInputRef.current) {
                      this.fileInputRef.current.value = "";
                      this.fileInputRef.current.click();
                    }
                  }}
                  onDragEnter={e => this.handleDrag(e)}
                  onDragOver={e => this.handleDrag(e)}
                  onDragLeave={e => this.handleDrag(e)}
                  onDrop={e => this.handleDrop(e)}
                  id="drop-area"
                  className="border border-primary rounded p-4 text-center bg-light draggable"
                  style={{ borderStyle: "dashed", cursor: "pointer" }}
                >
                  {!this.state.file ? (
                    <>
                      <FontAwesomeIcon
                        icon={faArrowUp}
                        className="mr-2 icon"
                        size="lg"
                      />
                      <h4 className="mt-3 text">
                        Arrastra y suelta tus archivos aquí
                      </h4>
                      <p className="subtitle text">
                        o haz clic para seleccionar
                      </p>

                      <input
                        ref={this.fileInputRef}
                        type="file"
                        id="fileCsv"
                        className="d-none"
                        onChange={e => this.handleFileChange(e)}
                      />
                    </>
                  ) : (
                    <>
                      <FontAwesomeIcon
                        icon={faFileCsv}
                        className="mr-2"
                        color="rgb(25, 151, 0"
                        size="3x"
                      />
                      <h4 className="mt-3">{this.state.file.name}</h4>
                      <p className="text-muted">
                        {(this.state.file.size / 1024).toFixed(2)} KB
                      </p>
                    </>
                  )}
                </div>
              </>
            ) : (
              <Table className="table table-responsive table-hover">
                <thead>
                  <tr>
                    <th scope="col">Detalle</th>
                    <th scope="col">No</th>
                    <th scope="col">Nombre</th>
                    <th scope="col">A. Paterno</th>
                    <th scope="col">A. Materno</th>
                    <th scope="col">Email</th>
                    <th scope="col">CC</th>
                    <th scope="col">Teléfono</th>
                    <th scope="col">Sexo</th>
                    <th scope="col">Fecha nacimiento</th>
                    <th scope="col">CURP</th>
                    <th scope="col">Curp Familiar</th>
                    <th scope="col">Extranjero</th>
                    <th scope="col">Incio vigencia</th>
                    <th scope="col">Fin vigencia</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.data &&
                    this.state.data.map((person, index) => (
                      <tr key={index}>
                        <td>
                          <span id={`row-${index}`}>
                            {person.errors.length > 0 ? (
                              <>
                                <FontAwesomeIcon
                                  icon={faInfoCircle}
                                  className="mr-2"
                                  size="lg"
                                  color="#600"
                                />
                                <UncontrolledTooltip
                                  placement="left"
                                  target={`row-${index}`}
                                >
                                  {person.errors.map(error => error + ", ")}
                                </UncontrolledTooltip>
                              </>
                            ) : (
                              <>
                                <FontAwesomeIcon
                                  icon={faCheck}
                                  className="mr-2"
                                  size="lg"
                                  color="rgb(25, 151, 0"
                                />
                                <UncontrolledTooltip
                                  placement="left"
                                  target={`row-${index}`}
                                >
                                  OK
                                </UncontrolledTooltip>
                              </>
                            )}
                          </span>
                        </td>
                        <td>{index + 1}</td>
                        <td>{person.firstName}</td>
                        <td>{person.paternalLastName}</td>
                        <td>{person.maternalLastName}</td>
                        <td>{person.email}</td>
                        <td>{person.cc}</td>
                        <td>{person.phone}</td>
                        <td>{person.gender}</td>
                        <td>{person.birthdate}</td>
                        <td>{person.curp}</td>
                        <td>{person.familyMemberCurp}</td>
                        <td>{person.foreignerCode}</td>
                        <td>{person.sstartsAt}</td>
                        <td>{person.sexpiresAt}</td>
                      </tr>
                    ))}
                </tbody>
                <tfoot>
                  <tr>
                    <th scope="col">Detalle</th>
                    <th scope="col">No</th>
                    <th scope="col">Nombre</th>
                    <th scope="col">A. Paterno</th>
                    <th scope="col">A. Materno</th>
                    <th scope="col">Email</th>
                    <th scope="col">CC</th>
                    <th scope="col">Teléfono</th>
                    <th scope="col">Sexo</th>
                    <th scope="col">Fecha nacimiento</th>
                    <th scope="col">CURP</th>
                    <th scope="col">Curp Familiar</th>
                    <th scope="col">Extranjero</th>
                    <th scope="col">Incio vigencia</th>
                    <th scope="col">Fin vigencia</th>
                  </tr>
                </tfoot>
              </Table>
            )}
          </Container>
        </ModalBody>

        <ModalFooter>
          <Button
            color="light"
            onClick={() => this.reset()}
            disabled={this.state.loading}
          >
            Reiniciar
          </Button>

          <Button
            color="dark"
            disabled={
              this.state.loading ||
              !this.state.file ||
              (this.state.validateFile && !this.state.hasGuestToSave)
            }
            onClick={e =>
              this.state.validateFile
                ? this.saveSpecialGuest(e)
                : this.validatePersons(e)
            }
            className="d-inline-flex align-items-center"
          >
            {this.state.loading ? (
              <>
                {this.state.validateFile
                  ? "Guardando invitados..."
                  : "Validando archivo..."}

                <span
                  className="spinner-border spinner-border-sm ml-2"
                  role="status"
                  aria-hidden="true"
                ></span>
              </>
            ) : (
              <>
                {this.state.validateFile
                  ? "Guardar invitados"
                  : "Validar archivo"}
                <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
              </>
            )}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}
